import { render, staticRenderFns } from "./ja.svg?vue&type=template&id=72371be8&"
var script = {}


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports